/**
 * Lokalgrow Assets Index
 * 
 * This file provides centralized imports for all image assets.
 * Assets are imported via webpack for optimization and cache-busting.
 * 
 * USAGE:
 * import { LOGO, FAVICON, PIN_ICON } from '../assets';
 * <img src={LOGO} alt="Lokalgrow" />
 * 
 * NOTE: PWA icons remain in /public as required by manifest.json
 */

// ============================================
// LOGOS
// ============================================
import logoMain from './images/logos/lokalgrow-logo.png';
import logoTransparent from './images/logos/lokalgrow-logo-transparent.png';
import logoFull from './images/logos/lokalgrow-logo-full.png';
import logoHorizontal from './images/logos/lokalgrow-logo-horizontal-new.png';

export const LOGO = logoMain;
export const LOGO_TRANSPARENT = logoTransparent;
export const LOGO_FULL = logoFull;
export const LOGO_HORIZONTAL = logoHorizontal;

// ============================================
// ICONS
// ============================================
import iconMain from './images/icons/lokalgrow-icon.png';
import iconFavicon from './images/icons/lokalgrow-favicon.png';
import iconSocial from './images/icons/lokalgrow-social.png';

export const FAVICON = iconMain;
export const FAVICON_OLD = iconFavicon;
export const SOCIAL_IMAGE = iconSocial;

// ============================================
// MAP PINS
// ============================================
import pinPng from './images/pins/lokalgrow-pin-16.png';
import pinSvg from './images/pins/lokalgrow-pin.svg';

export const PIN_ICON_16 = pinPng;
export const PIN_ICON_SVG = pinSvg;

// ============================================
// LEAFLET MAP CONFIGURATION
// ============================================
export const LEAFLET_ICON_CONFIG = {
  iconUrl: PIN_ICON_16,
  iconRetinaUrl: PIN_ICON_16,
  iconSize: [24, 24],
  iconAnchor: [12, 24],
  popupAnchor: [0, -24]
};

export const LEAFLET_USER_ICON_CONFIG = {
  iconRetinaUrl: PIN_ICON_16,
  iconUrl: PIN_ICON_16,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32]
};

// ============================================
// DEFAULT EXPORT
// ============================================
const assets = {
  // Logos
  LOGO,
  LOGO_TRANSPARENT,
  LOGO_FULL,
  LOGO_HORIZONTAL,
  // Icons
  FAVICON,
  FAVICON_OLD,
  SOCIAL_IMAGE,
  // Pins
  PIN_ICON_16,
  PIN_ICON_SVG,
  // Leaflet configs
  LEAFLET_ICON_CONFIG,
  LEAFLET_USER_ICON_CONFIG
};

export default assets;
